import { FontConfigMap } from './types/propTypes';

const fonts = [
  {
    fontSize: '42px',
    lineHeight: '48px',
    className: 'font-h2',
  },
  {
    fontSize: '32px',
    lineHeight: '36px',
    className: 'font-h3',
  },
  {
    fontSize: '24px',
    lineHeight: '28px',
    className: 'font-h4',
  },
  {
    fontSize: '21px',
    lineHeight: '24px',
    className: 'subtitle-1',
  },
  {
    fontSize: '18px',
    lineHeight: '21px',
    className: 'subtitle-2',
  },
  {
    fontSize: '16px',
    lineHeight: '20px',
    className: 'font-16-20',
  },
];

export const fontConfigMap: FontConfigMap = {
  desktop: [
    {
      ...fonts[0],
      maxLine: 2,
    },
    {
      ...fonts[1],
      maxLine: 3,
    },
    {
      ...fonts[2],
      maxLine: 4,
    },
    {
      ...fonts[3],
      default: true,
    },
  ],
  mobile: [
    {
      ...fonts[2],
      maxLine: 2,
    },
    {
      ...fonts[3],
      maxLine: 3,
    },
    {
      ...fonts[4],
      maxLine: 4,
    },
    {
      ...fonts[5],
      default: true,
    },
  ],
};
